import { Component , Input} from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Location } from '@angular/common';
import { LanguageService } from '../../../core/services/language.service';
import { SidebarComponent } from "../sidebar/sidebar.component";
import { Router } from '@angular/router';
@Component({
  selector: 'app-header',
  imports: [CommonModule, FormsModule, SidebarComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  @Input() showBack = true;
  canGoBack = false;
  showSidebar : boolean = false;
  isNotification : boolean = false;
  isShowModalNotification : boolean = false;

  // Notification
  listNotification : any = [
    // { id: 1 , data : 'แจ้งเตือน 1' },
    // { id: 2 , data : 'แจ้งเตือน 2' },
    // { id: 3 , data : 'แจ้งเตือน 3' },
    // { id: 4 , data : 'แจ้งเตือน 4' },
  ]

  currentLang:  'TH' | 'EN' = 'TH';

  constructor(private location: Location, private langService: LanguageService , private router: Router) {

  }

  ngOnInit() {
    // บางครั้ง window.history.length รวมหน้าอื่นใน browser → ถ้ากังวลให้ใช้ service route แทนได้
    this.canGoBack = window.history.length > 1;

        // subscribe เพื่ออัปเดต currentLang ทุกครั้งที่เปลี่ยน
    this.langService.currentLang$.subscribe(lang => {
      this.currentLang = lang;
    });
  }

  
  /* ------------------------------------------- Function ----------------------------------------- */
  goBack() {
    if (this.canGoBack) {
      this.location.back();
    } else {
      // fallback เช่นไปหน้า home
      window.location.href = '/';
    }
  }

  /*--- เปิด/ปิด modal ---*/
  toggleModal( modal : string  ) {
    if( modal === 'notification' ) {
      this.isNotification = !this.isNotification;
    }
    else if ( modal === 'menu' ) {
      this.showSidebar = !this.showSidebar
    }
  }
  /*--- route ---*/
  navigateRoute( from : string , where : string ) {
    if ( from === 'notification' ) {
      this.isNotification = false;
      this.router.navigate([where]);
    }
  }

  toggleLang() {
    this.langService.switchLang();
  }


  onChangeMenuStatus( event : boolean ) {
    this.showSidebar = event;
  }

}
